import React from 'react';

import { IconProps } from './types';

/**
 * The 16px "repeats" glyph on the event hero's recurrence chip: two arrows
 * chasing each other round a circle.
 *
 * The path is the Figma export's own (`my-personal`, "Update Left Rotation
 * Material Rounded"), in its original 12x12 space, translated by (2, 2) into
 * the 16px box it sits in there. Filled with `currentColor` rather than the
 * export's hardcoded black, so the chip sets its colour.
 */
export const RecurrenceIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M6 0C4.34028 0 2.78212 0.690104 1.6658 1.86024L0.568576 0.764757C0.439236 0.634549 0.227431 0.634549 0.0980903 0.764757C0.0329863 0.829861 0 0.914931 0 1V4C0 4.36806 0.298611 4.66667 0.666667 4.66667H3.66667C3.75174 4.66667 3.83767 4.63455 3.90191 4.56858C4.03212 4.43924 4.03212 4.22743 3.90191 4.09809L2.60938 2.80469C3.48003 1.88021 4.69965 1.33333 6 1.33333C8.34635 1.33333 10.3351 3.08767 10.6259 5.4158C10.6684 5.7526 10.9549 6 11.2865 6C11.3134 6 11.342 5.99913 11.3698 5.99479C11.7352 5.94965 11.9948 5.61632 11.9488 5.25087C11.5755 2.25781 9.01736 0 6 0ZM0.630209 6.00521C0.264757 6.05035 0.00520839 6.38368 0.0512153 6.74913C0.424479 9.74219 2.98264 12 6 12C7.65799 12 9.20486 11.3247 10.3333 10.138L11.4306 11.2361C11.5608 11.3655 11.7726 11.3655 11.9028 11.2361C11.967 11.1701 12 11.0851 12 11V8C12 7.63194 11.7014 7.33333 11.3333 7.33333H8.33333C8.24826 7.33333 8.16233 7.36545 8.09722 7.43056C7.96788 7.56076 7.96788 7.77257 8.09722 7.90278L9.39063 9.19531C8.51128 10.1328 7.29948 10.6667 6 10.6667C3.65365 10.6667 1.66493 8.91233 1.37413 6.5842C1.32812 6.21962 0.993056 5.95747 0.630209 6.00521Z"
          fill={color}
          transform="translate(2 2)"
        />
      </svg>
    );
  },
);
